"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        item: {
            position: 'relative',
            wordBreak: 'break-word',
            width: '100%',
            padding: '0 24px',
            height: theme_1.default.menuItemHeight,
            minHeight: "".concat(theme_1.default.menuItemHeight, "px !important"),
            // MUI attaches its own backgroundColor on hover
            '&:hover': {
                backgroundColor: 'inherit',
            },
        },
        selectableItem: {
            height: 'auto',
            minHeight: "".concat(theme_1.default.menuItemHeight, "px !important"),
            padding: '12px 24px',
            fontWeight: 'bold',
            whiteSpace: 'normal',
            backgroundColor: 'white !important',
        },
        selectableItemHover: {
            '&:hover, &[data-focus="true"]': {
                backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.2), " !important"),
                color: theme_1.default.textColors.highlight,
            },
            cursor: 'pointer !important',
        },
        root: __assign({}, theme_1.default.fonts.headline3),
        disabled: function (_a) {
            var hasTooltip = _a.hasTooltip;
            return ({
                cursor: 'not-allowed !important',
                position: hasTooltip ? 'relative' : undefined,
                // pseudo element is needed for the tooltip to be displayed on disabled menu items
                '&::before': {
                    content: hasTooltip ? '""' : 'none',
                    display: 'block',
                    pointerEvents: 'auto',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                },
            });
        },
        selected: {
            color: "".concat(theme_1.default.textColors.highlight, " !important"),
        },
        icon: {
            paddingLeft: 16,
            margin: '-4px 0px -4px auto',
        },
        invisible: {
            visibility: 'hidden',
        },
        disablePadding: {
            padding: '0px',
            paddingRight: '12px',
        },
        tooltipTrigger: {
            pointerEvents: 'auto',
            position: 'absolute',
            width: '100%',
            height: '100%',
        },
    });
});
